import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
	root: {},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			width: "100%",
			display: "flex",
			justifyContent: "space-between",
		},
	},
}));

const TagsListWrapper = (props) => {
	const classes = useStyles();

	return <div className={classes.root}>{props.children}</div>;
};

export default TagsListWrapper;
